import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ApiService} from '../../api.service';
import {Store} from '@ngrx/store';
import {GlobalService} from '../../global.service';
import {Router} from '@angular/router';
import {element} from 'protractor';

@Component({
    selector: 'app-devices',
    templateUrl: './devices.component.html',
    styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit, AfterViewInit {

    constructor(private apiService: ApiService, private store: Store<any>,
                private globalService: GlobalService, private router: Router) {
        var set = this.globalService.getSession('mainApplication');
        $(window).ready(function () {
            if (set) {
                if (set.deviceId) {
                    $('.device_' + set.deviceId).addClass('device-active');
                } else {
                    $('.package-devices').removeClass('device-active');
                }
            } else {
                // console.log(false)
            }
        });


    }

    //khoi tao
    data_devices: any = [];
    data_plans: any = [];
    list_data_devices: any = [];
    list_data_plans: any = [];

    is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    ngOnInit() {


        /**get devices */
        $('title').html(this.globalService.getSession('viewPlan').attributes.campaign_name);
        this.list_data_devices = this.globalService.getSession('viewPlan').attributes.devices;
        this.list_data_plans = this.globalService.getSession('viewPlan').attributes.plans;

        this.data_devices = this.list_data_devices;
        this.data_plans = this.list_data_plans;
        this.data_devices.forEach(d => {

            /**change image 'no-device' when data_devices[i].image == '' || null */
            if (!d.image || d.image === '') {
                d.image = '../../assets/images/no_device.png';
            }

            /**add data plan_title for devices */
            this.data_plans.forEach(p => {
                if (p.id === d.pivot.plan_id) {
                    p.plan_id = d.pivot.plan_id;
                    d.plan_title = p.plan_title;
                }
                return false;
            });
        });

        /** sort device by device_rrp */
        this.data_devices.sort(function (a, b) {
            return a.device_rrp - b.device_rrp;
        });

        var count = 0;
        this.data_devices.forEach((element, key) => {

            /**cut item when is_show == 0 on array */
            if (element.is_show == 0) {
                count++;
                this.data_devices.splice(key, 1);
            }

            /**hide view device when all data_devices has is_show == 0*/
            if (count == this.data_devices.length) {
                $('.check--is_show').hide();
            }
        });

        /** css when data < 4 and check style on safari*/
        if (this.data_devices.length < 4) {
            $('.devices_pc').addClass('justify-content-md-center');
        } else {
            $('.devices_pc').removeClass('justify-content-md-center');
            let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
                // console.log('You are using Safari on iOS!');
                $('.devices_pc').css('display', 'block');

            } else {
                // console.log("other.");
            }
        }

        /** load slider */
        $(window).on('load', function () {
            //layout mobile
            (<any>$)('.device-slider_mobile').on('init , setPosition', function () {
                if ($(window).outerWidth() <= 768) {
                    $('.devices_pc').hide();
                    $('.device-slider_mobile .slick-list').css('padding', '0px 15px');
                    $('.device-slider_mobile').show();
                } else {
                    $('.device-slider_mobile').hide();
                    $('.devices_pc').show();
                }
            });

            //slider mobile
            (<any>$)('.device-slider_mobile').not('.slick-initialized').slick({
                slidesToShow: 1,
                dots: true,
                infinite: false,
                centerMode: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 1500,
            });
        });

        setTimeout(() => {

            if (this.data_devices.length < 4) {
                $('.devices_pc').addClass('justify-content-md-center');
            } else {
                $('.devices_pc').removeClass('justify-content-md-center');
            }
        }, 0);


    }

    ngAfterViewInit(): void {
        //layout mobile
        (<any>$)('.device-slider_mobile').on('init , setPosition', function () {
            if ($(window).outerWidth() <= 768) {
                $('.devices_pc').hide();
                $('.device-slider_mobile .slick-list').css('padding', '0px 15px');
                $('.device-slider_mobile').show();
            } else {
                $('.device-slider_mobile').hide();
                $('.devices_pc').show();
            }
        });

        //slider mobile
        (<any>$)('.device-slider_mobile').not('.slick-initialized').slick({
            slidesToShow: 1,
            dots: true,
            infinite: false,
            centerMode: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 1500,
        });
    }


    onChooseDevice(item) {
        $('.package-devices').removeClass('device-active');
        $('.device_' + item.id).toggleClass('device-active');

        /** save data device on select to session */
        let newValueSession = Object.assign({}, this.globalService.getSession('mainApplication'), {
            deviceId: item.id,
            planId: item.pivot.plan_id
        });

        /** choose device and get broadband */
        let dataRequestBroadbrand = {
            campaign_Id: parseInt(this.globalService.getSession('id_campaign')),
            plan_Id: item.pivot.plan_id
        };

        this.apiService.getBroadbrand(dataRequestBroadbrand).subscribe(res => {
            this.globalService.setSession('broad_plan', res.data.broad_plan.original.data.collection);
        });

        /**save session */
        this.globalService.setSession('mainApplication', newValueSession);
        this.globalService.setSession('digi_type', 'plans_type');

        /**redirect to main-campaign */
        this.router.navigateByUrl('/main-campaign');
    }

}
